import PropTypes from 'prop-types';
import { Grid, TextField, InputAdornment } from '@mui/material';
import { LocationOnOutlined } from '@mui/icons-material';
import SectionHeader from '../SectionHeader';
import SearchableSelect from '../SearchableSelect';

const LocationSection = ({ form, handleChange, handleBlur, errors, touched, state, district, cities }) => {
    const cityOptions = [...cities, { id: 'other', name: 'Other' }];

    return (
        <>
            <SectionHeader icon={LocationOnOutlined} title="Location" subtitle="State, District & City assignment" />
            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={4}>
                    <SearchableSelect
                        label="State"
                        required
                        value={form.state}
                        onChange={handleChange('state')}
                        onBlur={handleBlur('state')}
                        options={state}
                        error={touched.state && !!errors.state}
                        helperText={touched.state && errors.state}
                        icon={LocationOnOutlined}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <SearchableSelect
                        label="District"
                        required
                        value={form.district}
                        onChange={handleChange('district')}
                        onBlur={handleBlur('district')}
                        options={district}
                        disabled={!form.state}
                        error={touched.district && !!errors.district}
                        helperText={(touched.district && errors.district) || (!form.state ? 'Select a state first' : '')}
                        icon={LocationOnOutlined}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <SearchableSelect
                        label="City"
                        required
                        value={form.city}
                        onChange={handleChange('city')}
                        onBlur={handleBlur('city')}
                        options={cityOptions}
                        disabled={!form.district}
                        error={touched.city && !!errors.city}
                        helperText={(touched.city && errors.city) || (!form.district ? 'Select a district first' : '')}
                        icon={LocationOnOutlined}
                    />
                </Grid>
                {form.city === 'other' && (
                    <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            label="Type City Name"
                            required
                            value={form.customCity}
                            onChange={handleChange('customCity')}
                            onBlur={handleBlur('customCity')}
                            error={touched.customCity && !!errors.customCity}
                            helperText={touched.customCity && errors.customCity}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LocationOnOutlined
                                            fontSize="small"
                                            color={touched.customCity && errors.customCity ? 'error' : 'action'}
                                        />
                                    </InputAdornment>
                                )
                            }}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                        />
                    </Grid>
                )}
            </Grid>
        </>
    );
};

LocationSection.propTypes = {
    form: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    state: PropTypes.array.isRequired,
    district: PropTypes.array.isRequired,
    cities: PropTypes.array.isRequired
};

export default LocationSection;
